var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalystAdvisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 14.4512C10.251 14.5043 10.017 14.5637 9.7875 14.6253C8.2125 15.0843 6.732 15.807 5.4 16.7628C4.8465 17.1975 4.5135 17.8581 4.5 18.5628V23.0628H11.466L10.4805 14.4512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.71875C18 11.2041 15.984 13.2188 13.5 13.2188C11.016 13.2188 9 11.2041 9 8.71875C9 6.2334 11.016 4.21875 13.5 4.21875C15.984 4.21875 18 6.2334 18 8.71875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 16.7626C20.3627 15.7501 18.7877 15.0751 17.2127 14.6251C16.9877 14.5576 16.7537 14.4955 16.5197 14.4365L15.5342 23.0626H22.5002V18.5626C22.4867 17.8579 22.1537 17.1973 21.6002 16.7626ZM20.5292 19.9688H17.7212V19.4063H20.5292V19.9688Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3597 15.75L14.9042 14.0625H12.0962L12.6407 15.75H14.3597Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6809 16.3125L12.2983 21.8614L13.4999 23.0625L14.7014 21.8614L14.3188 16.3125H12.6809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalystAdvisor);
export default __webpack_public_path__ + "static/media/icon-analyst-advisor.5910a575c60b98d59d6f767a1551a810.svg";
export { ForwardRef as ReactComponent };